angular
  .module('contrast.factory.security', [])
  .factory('SecurityFactory', function ($http, $q, UserService) {
    return {
      //ip ranges
      getIPRanges: function () {
        return $http.get(UserService.buildAPIUrl('/security/iprange'))
      },
      addIPRange: function (range) {
        return $http.post(UserService.buildAPIUrl('/security/iprange'), {
          ipRange: [range]
        })
      },
      addIPRanges: function (ranges) {
        return $http.post(UserService.buildAPIUrl('/security/iprange'), {
          ipRange: ranges
        })
      },
      deleteIPRange: function (ranges) {
        const data = { ipRange: ranges }
        return $http['delete'](UserService.buildAPIUrl('/security/iprange'), {
          data,
          headers: { 'Content-Type': 'application/json' }
        })
      },

      //timeouts
      getTimeouts: function () {
        return $http.get(UserService.buildAPIUrl('/security/timeouts'))
      },
      updateTimeouts: function (absolute, idle) {
        return $http.put(UserService.buildAPIUrl('/security/timeouts'), {
          absolute_timeout: absolute,
          idle_timeout: idle
        })
      },

      //audit
      getLogs: function (data) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/security/audit'),
          params: data,
          timeout: httpTimeout.promise
        })
        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      }
    }
  })
